/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Icon_Leaf_Simple1Inputs */

const vi_sitesettings_icon_leaf_simple1 = /** @type {(inputs: Sitesettings_Icon_Leaf_Simple1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lá chè (đơn giản)`)
};

/**

* @param {Sitesettings_Icon_Leaf_Simple1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_icon_leaf_simple1 = /** @type {((inputs?: Sitesettings_Icon_Leaf_Simple1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Icon_Leaf_Simple1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_icon_leaf_simple1(inputs)
});
export { sitesettings_icon_leaf_simple1 as "siteSettings_icon_leaf_simple" }